import './FlightAuthorityStageOsd.sass'
import OsdFloatBox from '../../OsdFloatBox/OsdFloatBox'
import { useDispatch, useSelector } from 'react-redux'
import { TbKey } from 'react-icons/tb';
import { BiJoystickButton } from 'react-icons/bi';
import useDeviceFlightAuthority from 'src/services/device/common/useDeviceFlightAuthority';
import { DjiFlightJoystickAuthorityMode, DjiFlightJoystickAuthorityModeText } from 'src/services/device/common/deviceConstants';
import classNames from 'classnames';
import { setDeviceFlightAuthorityStatus } from 'src/services/device/DeviceServiceSlice';

function FlightAuthorityStageOsd({ entity, style, stageSplitted }) {
  const dispatch = useDispatch();
  const flightAuthority = useDeviceFlightAuthority(entity?.id);
  const flightAuthorityText = DjiFlightJoystickAuthorityModeText[flightAuthority?.authorityMode];

  const warningStyle = {
    ...(style || {}),
    border: '1px solid yellow'
  };

  const handleWarningClose = () => {
    dispatch(setDeviceFlightAuthorityStatus({
      deviceId: entity?.id,
      data: {
        requiredAuthorityError: null,
      }
    }));
  }

  let warningMessage = null;

  if (flightAuthority?.requiredAuthorityError === DjiFlightJoystickAuthorityMode.PSDK) {
    warningMessage = (
      <>
        Please press Shift + O to get 5G flight authority.
        {flightAuthority?.authorityMode === DjiFlightJoystickAuthorityMode.DOCK && (
          <>
            <br />
            You may also switch to dock SDR view to control the drone.
          </>
        )}
      </>
    );
  }

  if (flightAuthority?.requiredAuthorityError === DjiFlightJoystickAuthorityMode.DOCK) {
    warningMessage = (
      <>
        Please activate DRC mode using CTRL button in device sidebar to get flight authority.
        {flightAuthority?.authorityMode === DjiFlightJoystickAuthorityMode.PSDK && (
          <>
            <br />
            You may also continue to use 5G control here or switch to 5G view.
          </>
        )}
      </>
    );
  }

  return !entity || !stageSplitted || (!flightAuthorityText && !warningMessage) ? null : <>
    {!warningMessage ? (
      <div className={classNames("flight-authority-stage-osd", {'loading': flightAuthority?.activeRequest})}>
        <div className="status" title="Flight Authority Status">
          <BiJoystickButton className="icon" />
          <div className="text">{ `${flightAuthorityText} has control authority` }</div>
        </div>
      </div>
    ) : (
      <OsdFloatBox title="Flight Authority Warning" style={warningStyle} onClose={handleWarningClose} icon={TbKey}>
        <div className="flight-authority-warning">
          {warningMessage}
        </div>
      </OsdFloatBox>
    )}
  </>
}

export default FlightAuthorityStageOsd